<template>
    <div>
        <div v-if="authUserPermission['stock-calc-slow-by-manual']">
            <div class="container-fluid mt-4">
                <div class="row no-gutters justify-content-center mb-4">
                    <div class="col-md-5">
                        <button v-if="[1,2].includes(params.flag)" class="btn-sm btn m-0 w-100 rounded-0 p-2"
                            :class="params.flag == 1 ? 'btn-darks' : 'btn-light'" @click="goToFrontPage(1)">
                            Draft</button>
                        <button v-if="[3,4].includes(params.flag)" class="btn-sm btn m-0 w-100 rounded-0 p-2"
                            :class="params.flag == 3 ? 'btn-darks' : 'btn-light'" @click="goToFrontPage(3)">
                            Waiting Approval</button>
                    </div>
                    <div class="col-md-5">
                        <button v-if="[1,2].includes(params.flag)" class="btn-sm w-100 btn-rounded-non btn p-2"
                            :class="params.flag == 2 ? 'btn-darks' : 'btn-light'" @click="goToFrontPage(2)">
                            submissions</button>
                        <button v-if="[3,4].includes(params.flag)" class="btn-sm w-100 btn-rounded-non btn p-2"
                            :class="params.flag == 4 ? 'btn-darks' : 'btn-light'" @click="goToFrontPage(4)">
                            Histor Approval</button>
                    </div>
                </div>
                <div class="card mb-4 rounded-0" style="font-size: 12px!important;">
                    <div class="card-body">
                        <table class="table table-borderless">
                            <tbody>
                                <tr>
                                    <td class="py-1">Nama</td>
                                    <td class="py-1">NIK</td>
                                    <td class="py-1">Departemen</td>
                                    <td class="py-1">Perusahaan</td>
                                    <td class="py-1">Tanggal</td>
                                </tr>
                                <tr>
                                    <td class="py-1 font-weight-bolder">{{ data?.submitted_name ?? '-' }}</td>
                                    <td class="py-1 font-weight-bolder">{{ data?.submitted_by  ?? '-' }}</td>
                                    <td class="py-1 font-weight-bolder">{{ data?.department ?? '-' }}</td>
                                    <td class="py-1 font-weight-bolder">{{ data?.sales_org_description ?? '' }}</td>
                                    <td class="py-1 font-weight-bolder">{{ formatTanggal(data?.created_at) }}</td>
                                </tr>
                                <tr>
                                    <td class="py-1 pt-3">Judul</td>
                                    <td class="py-1 pt-3">Kategori</td>
                                </tr>
                                <tr>
                                    <td class="py-1 font-weight-bolder">{{ data?.title ?? '-' }}</td>
                                    <td class="py-1 font-weight-bolder">{{ '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card mb-4 rounded-0" style="font-size: 12px!important;">
                    <div class="card-body">
                        <div class="title mb-3"><span>Submission Status History</span></div>
                        <table class="table table-borderless">
                            <tbody>
                                <tr v-for="(history, index) in data?.histories" :key="index">
                                    <td class="py-1 pl-0" style="width: 0.5%!important;"><span class="badge" :class="getBgHistory(history.status)">{{ history.status_text }}</span></td>
                                    <td class="py-1 pl-0">{{ formatTanggal(history?.created_at, 'DD/MM/YYYY HH:mm:ss') + ' - ' + (history?.description ?? '') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card mb-4 rounded-0" style="font-size: 12px!important;">
                    <div class="card-body">

                        <stock-calc-sumary-table :data="data" :items="data?.items" />

                        <div class="d-flex justify-content-center mb-4">
                            <base-button v-if="[3,5].includes(data?.status) && (authUser?.namecode == data?.submitted_by)" type="success" class="btn px-5" @click="resubmit">Resubmit</base-button>
                            <base-button v-if="data?.status == 2 && (authUser?.namecode == data?.assigned_to)" class="btn btn-yellow px-5" @click="() => visibleModalRevisi = true" :loading="loadingRevisi">Revisi</base-button>
                            <base-button v-if="data?.status == 2 && (authUser?.namecode == data?.assigned_to)" type="danger" class="btn px-5" @click="() => visibleModalReject = true" :loading="loadingReject">Reject</base-button>
                            <base-button v-if="data?.status == 2 && (authUser?.namecode == data?.assigned_to)" type="success" class="btn px-5" @click="approve" :loading="loadingApprove">Approve</base-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- modal revisi -->
            <el-dialog title="Revisi" :visible.sync="visibleModalRevisi" width="30%"
                :before-close="() => visibleModalRevisi = false" :close-on-click-modal="false">
                <div class="mb-4">
                        <label class="form-control-label">Komentar <span class="text-danger">*</span></label>
                        <input placeholder="Tulis komentar disini..." type="text" class="form-control" v-model="description">
                    </div>
                    <div class="d-flex justify-content-end">
                        <base-button type="light" @click="() => visibleModalRevisi = false" :loading="loadingRevisi">
                            Batal
                        </base-button>
                        <base-button class="btn-yellow" @click="revisiReject(1)" :loading="loadingRevisi">
                            Send
                        </base-button>
                    </div>
            </el-dialog>

            <!-- modal reject -->
            <el-dialog title="Reject" :visible.sync="visibleModalReject" width="30%"
                :before-close="() => visibleModalReject = false" :close-on-click-modal="false">
                <div class="mb-4">
                        <label class="form-control-label">Komentar <span class="text-danger">*</span></label>
                        <input placeholder="Tulis komentar disini..." type="text" class="form-control" v-model="description">
                    </div>
                    <div class="d-flex justify-content-end">
                        <base-button type="light" @click="() => visibleModalReject = false" :loading="loadingReject">
                            Batal
                        </base-button>
                        <base-button type="danger" @click="revisiReject(2)" :loading="loadingReject">
                            Send
                        </base-button>
                    </div>
            </el-dialog>
        </div>
        <noaccess v-else />
    </div>
</template>
<script>
import { mapState } from 'vuex'
import Api from '@/helpers/api';
import Empty from '../../components/Empty.vue';
import stockCalcService from '@/services/material/stockCalculation.service';
import moment from 'moment';
import 'moment/locale/id'
import StockCalcSumaryTable from '@/views/StockCalculation/Components/StockCalcSumaryTable.vue';
import Swal from "sweetalert2";

export default {
    name: 'StockCalcSubmissionsSubmit',
    components: {
        Empty,
        StockCalcSumaryTable
    },
    data() {
        return {
            id: null,
            data: null,
            loadingPage: false,
            params: {
                flag: null
            },
            visibleModalRevisi: false,
            visibleModalReject: false,
            loadingRevisi: false,
            loadingReject: false,
            loadingApprove: false,
            description: ''
        }
    },
    methods: {
        goToFrontPage(value) {
            if ([3,4].includes(value)) {
                this.$router.push(`/stock-calculation/stock-calc-submissions/approval?flag=${value}`);
            } else {
                this.$router.push(`/stock-calculation/stock-calc-submissions?flag=${value}`);
            }
        },
        resubmit() {
            this.$router.push(`/stock-calculation/stock-calc-submissions/submit/${this.id}?flag=1`);
        },
        approve() {
             Swal.fire({
                title: "Confirmation",
                html: "Apakah Anda yakin?",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#5e72e4",
                cancelButtonColor: "#f5365c",
                confirmButtonText: "Yes",
                heightAuto: false,
            }).then(async (result) => {
                this.loadingApprove = true
                if (result.isConfirmed) {
                    Api(this, stockCalcService.approve(this.id))
                        .onSuccess((response) => {
                            Swal.fire({
                                title: 'Sukses!',
                                text: 'Data berhasil disetujui.',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            }).then(() => {
                                this.getDetail(this.id)
                                this.params.flag = 4
                            })
                        })
                        .onError((error) => {
                            const errorMessage = error?.response?.data?.message ?? 'Gagal, Terjadi kesalahan.'
                            this.$notify({
                                message: errorMessage,
                                type: 'danger',
                                verticalAlign: "bottom",
                                horizontalAlign: "left"
                            });
                        })
                        .onFinish(() => {
                            this.loadingApprove = false
                        })
                        .call()
                }
            })
        },
        revisiReject(flag) {
             Swal.fire({
                title: "Confirmation",
                html: "Apakah Anda yakin?",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#5e72e4",
                cancelButtonColor: "#f5365c",
                confirmButtonText: "Yes",
                heightAuto: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    flag == 1 ? this.loadingRevisi = true : this.loadingReject = true
                    const payload_data = {description: this.description}
                    Api(this, flag == 1 ? stockCalcService.revisi(this.id, payload_data) : stockCalcService.reject(this.id, payload_data))
                        .onSuccess((response) => {
                            Swal.fire({
                                title: 'Sukses!',
                                text: 'Data berhasil di' . flag == 1 ? 'revisi.' : 'reject.',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            }).then(() => {
                                this.getDetail(this.id)
                                this.params.flag = 4
                            })
                        })
                        .onError((error) => {
                            const errorMessage = error?.response?.data?.message ?? 'Gagal, Terjadi kesalahan.'
                            this.$notify({
                                message: errorMessage,
                                type: 'danger',
                                verticalAlign: "bottom",
                                horizontalAlign: "left"
                            });
                        })
                        .onFinish(() => {
                            if (flag == 1) {
                                this.loadingRevisi = false
                                this.visibleModalRevisi = false
                            } else {
                                this.loadingReject = false
                                this.visibleModalReject = false
                            }
                        })
                        .call()
                }
            })
        },
        getDetail(id) {
            this.loadingPage = true

            Api(this, stockCalcService.getSubmissionDetail(id))
                .onSuccess((response) => {
                    this.data = response?.data?.data
                })
                .onError((error) => {
                    const errorMessage = error?.response?.data?.message ?? 'Gagal, Terjadi kesalahan.'
                    this.$notify({
                        message: errorMessage,
                        type: 'danger',
                        verticalAlign: "bottom",
                        horizontalAlign: "left"
                    });
                })
                .onFinish(() => {
                    this.loadingPage = false
                })
                .call()
        },
        formatTanggal(value, format = 'D MMMM YYYY') {
            if (!value) return '-';
            return moment(value).format(format);
        },
        getBgHistory(status) {
            if (status == 2) {
                return 'badge-primary'
            } else if (status == 3) {
                return 'badge-primary'
            } else if (status == 4) {
                return 'badge-warning'
            } else if (status == 5) {
                return 'badge-success'
            } else {
                return 'badge-danger'
            }
        }
    },
    created() {
        moment.locale('id')
        this.id = this.$route.params.id
        this.getDetail(this.id)

        const flag = this.$route.query.flag;
        this.params.flag = flag ? parseInt(flag) : null
    },
    computed: {
        ...mapState({
            authUserPermission: state => state.auth.userPermission,
            authUser: (state) => state.auth.user
        })
    }
};
</script>


<style scoped>
.card {
    font-family: sans-serif;
    color: #000;
}

.el-tooltip__popper {
    max-width: 320px !important;
    word-break: break-word;
}

.btn-darks {
    background-color: #172b4d !important;
    color: white;
}

.badge {
    border-radius: 6px;
    font-size: 0.75rem;
}

.bg-yellow {
    background-color: yellow !important;
    color: silver !important;
}

.cursor-pointer {
    cursor: pointer !important;
}

.stepper {
    font-family: sans-serif;
    font-size: 14px;
    gap: 0.5rem;
}

.step {
    color: #000;
}

.step.active {
    font-weight: bold;
}
</style>